import { Box, Heading, Stack, Text } from "@chakra-ui/react";
import NextImage from "next/image";

import CustomLink from "components/Chakra/CustomLink";

const Footer = () => (
  <Stack
    background="linear-gradient(90deg, rgba(255,51,49,1) 0%, rgba(255,112,68,1) 60%, rgba(255,144,78,1) 100%)"
    spacing={0}
    position="relative"
    overflow="hidden"
  >
    <Stack
      margin={{ md: "0 auto" }}
      py="48px"
      px={{ base: "16px", sm: "40px" }}
    >
      <Stack
        spacing={0}
        zIndex={2}
        ml={{ md: "40px" }}
        sx={{
          "> p, h3": {
            color: "ud-white",
            textShadow: "0 1px 5px #212121",
          },
          "& span": {
            color: "ud-white",
            textShadow: "0 1px 5px #212121",
          },
        }}
      >
        <Heading as="h3" pl={{ base: "15px", md: 0 }} w={{ md: "908px" }}>
          5 000 Kč za doporučení majitele
        </Heading>
        <Text
          py={{ base: "16px" }}
          maxW={{ base: "200px", sm: "276px", md: "450px" }}
        >
          Máte kolem sebe někoho,{" "}
          <Text as="span" fontWeight={700}>
            kdo vlastní nemovitost a nechce se trápit s pronajímáním?
          </Text>
        </Text>
        <Text
          fontWeight={700}
          pb="40px"
          maxW={{ base: "200px", sm: "276px", md: "450px" }}
        >
          Doporučte nám jej,{" "}
          <Text as="span" fontWeight={400}>
            odměníme vás za každý byt, který se díky vám dostane do našeho
            portfolia.
          </Text>
        </Text>{" "}
        <CustomLink
          variant="button"
          borderRadius="full"
          w="fit-content"
          backgroundColor="ud-white"
          color="ud-primary"
          boxShadow="0 2px 15px rgba(33, 33, 33, 0.66)"
          href="https://idealninajemce.cz/doporucit-majitele"
          _hover={{
            backgroundColor: "ud-primary-200",
            color: "ud-primary",
            boxShadow: "0 2px 15px rgba(33, 33, 33, 0.66)",
          }}
          target="_blank"
        >
          Doporučit majitele
        </CustomLink>
      </Stack>
      <Box
        position="absolute"
        right={0}
        bottom={{ base: "-15px", xl: 0 }}
        w={{
          base: "50%",
          sm: "70%",
          xl: "80%",
        }}
        h="320px"
      >
        <NextImage
          src="/idealni-najemce-lp/img/pani_s_penizkama.png"
          alt="Background image"
          fill
          style={{ objectFit: "cover", objectPosition: "top" }}
        />
      </Box>
    </Stack>
  </Stack>
);

export default Footer;
